

<h2 mat-dialog-title>Perfil</h2>
<mat-dialog-content>
    <div class="perfil">
        <div class="img">
            <div class="foto"><img [src]="identity?.img ? identity.img : 'assets/images/photo.jpg'" name="aboutme" width="140" height="140" border="0" class="img-circle"></div>
            <div class="takePhoto"><mat-chip *ngIf="edit" (click)="updatePhoto()">
                    <mat-icon>add_a_photo</mat-icon>
            </mat-chip></div>
        </div>
        <h3 class="media-heading">{{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}</h3>
        <mat-chip-list>
            <mat-chip color="primary" selected>{{'Correo: '+identity.email}}</mat-chip>
            <mat-chip color="warn" selected>{{'Rut: '+identity.rut}}</mat-chip>
            <mat-chip color="primary" selected>{{'Telefono: '+identity.telefono}}</mat-chip>
          </mat-chip-list>
        <hr>
    
    
        <p class="text-left"><strong>Biografía: </strong><br>
            {{identity.bio ?  identity.bio : 'No existe biografia.'}}</p>
        <br>

    
    </div>



</mat-dialog-content>
<mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="cancelar" data-dismiss="modal" *ngIf="!edit" >Cerrar</button>
    <button matDialogClose mat-raised-button color="warn" id="cancelar" data-dismiss="modal" *ngIf="edit">Cancelar</button>
    <button  mat-raised-button  id="edit_perfil" data-dismiss="modal" (click)="edit = !edit" >Editar Perfil</button>

</mat-dialog-actions>